'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _spauiUtils = require('@tencent/spaui-utils');

/**
 * Coder 接口参数
 * @property {titleline} 全局属性
 * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
 * @property {titleline} 基础属性
 * @property {string} value='' 内容
 * @property {func} onChange 回调<br />onChange = (event, value)
 * @property {string} [placeholder=''] 提示
 * @property {bool} [disabled=false] 是否禁用
 * @property {func|element} [FooterComponent] 尾部结构&lt;FooterComponent value placeholder disabled /&gt;
 * @property {string} [footerClassName=''] 尾部结构父元素className
 */
exports.default = {
    value: {
        type: _spauiUtils.PropTypes.string.isRequired,
        defaultValue: ''
    },
    placeholder: {
        type: _spauiUtils.PropTypes.string,
        defaultValue: ''
    },
    onChange: {
        type: _spauiUtils.PropTypes.func.isRequired
    },
    disabled: {
        type: _spauiUtils.PropTypes.bool,
        defaultValue: false
    },
    FooterComponent: {
        type: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func])
    },
    footerClassName: {
        type: _spauiUtils.PropTypes.string,
        defaultValue: ''
    }
}; /**
   * Tencent is pleased to support the open source community by making SPA UI available.
   * Copyright (C) 2019, a Tencent company. All rights reserved.
   */
/**
 * @fileoverview 组件参数配置
 */